var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-viewer",style:({'border-color': _vm.borderColor})},[_c('img',{attrs:{"src":_vm.src}}),(_vm.$slots.default)?_c('div',{staticClass:"overlay-title px-2 py-1 mx-auto"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }